<template>
  <div class="main">
    <div class="name" :title="modelFileName" v-show="modelLoaded">
      <!-- <img src="img" alt="图标"> -->
      <span>{{modelFileName}}</span>
    </div>
    <!-- 小地图 -->
    <div class="minimaplevel" :style="{'left':marginLeft + 250 +'px'}" v-if="showminimaplevel">
      <el-select  v-model="mapdata" placeholder="请选择" size="mini" @change="setLevels">
        <el-option v-for="item in mapoptions" :key="item.id" :label="item.name" :value="item.elevation"></el-option>
      </el-select>
    </div>
    <modelView ref="modelView" @isShowTask="isShowTask"/>
    <div class="bottom" v-if="isTask">
      <div class="title">
        <i class="el-icon-video-play" v-if="!isViedo" @click="playVideo"></i>
        <i class="el-icon-video-pause" v-else @click="playVideo"></i>
        <span>{{startDate}}</span>
        <el-progress class="progress " :show-text="false" :percentage="percentage"></el-progress>
        <span>{{endDate}}</span>
      </div>
      <task-list class="taskList" ref="taskList" :getTaskList="getTaskList"></task-list>
    </div>
  </div>
</template>

<script>
import modelView from "./modelView.vue";
import taskList from "./taskList.vue"
export default {
  components:{ modelView,taskList },
  data(){
    return{
      modelLoaded:false,
      marginLeft: 0,//小地图左边距
      mapoptions: [],
      mapdata:'',
      showminimaplevel:false,
      showdwg:false,
      img:require("@/views/modelPro/images/title.png"),
      startDateList:[],
      isViedo:false,
      percentage:0,
      index:0,
      timer:null,
      taskList:[],
      isTask:false
    }
  },
  computed:{
    modelFileName(){
      return this.$route.query.fileNames || "未命名";
    },
    startDate(){
      const {startDateList,index,percentage,isViedo}=this;
      const length=startDateList.length;
      if(index&&index<length-1)return startDateList[this.index]
      else if(index==length-1)return startDateList[length-1] 
      else if(index==0&&percentage==100)return startDateList[length-1]
      else if(isViedo)return startDateList[0]
      else return "" 
    },
    endDate(){
      const length=this.startDateList.length
      return this.startDateList[length-1]
    },
    
  },
  watch:{
    startDate(val){
      //监听开始时间，当开始时间等于最晚时间时。按钮改为暂停按钮。进度条为100%
      if(val==this.endDate){
        this.isViedo=false;
        this.percentage=100;
        this.index=0;
        this.getElement(2)
      }else if(val==this.startDateList[0]){
        this.getElement(1)
      }
      if(val&&val!=this.endDate)this.getPropert(val)
    },
    //监听暂停---播放，执行时间函数。如果没有，则将其清除
    isViedo(val){
      if(val)this.timer=setInterval(this.testHtml, 1500);
      else clearInterval(this.timer)
    },
  },
  created(){
    if (!navigator.userAgent.match(/x64/i)) {
      this.$message({
        message: "为了您更流畅的体验，建议您使用64位浏览器",
        type: "warning",
        duration: 2000,
      });
    }
    
  },
  methods:{
    getElement(type){
      //隐藏所有的模型
      const modelinfos = Monge.Model.getModels();
      for(let x=0;x<modelinfos.length;x++){
        if(type===1) Monge.Model.ElementOperator.hide(modelinfos[x].id, 1)
        else Monge.Model.ElementOperator.show(modelinfos[x].id, 1)
      }
    },

    isShowTask(){
      /**模型加载完成显示下方任务列表*/
      this.isTask=true;
    },
    getPropert(val){
      this.getElement(1)
      //取出符合条件的任务
      const list=this.taskList.sort(function(a, b) { return b.startDate > a.startDate ? -1 : 1 })
      //取出播放 时间的所有任务
      const newArrar = list.filter((item) => { if(item.startDate <= val){ return item } })
      // 取出对应的工序编码。状态
      const array =newArrar.map((item)=>{return {operationCode:item.operationCode,status:item.taskStatusName,startDate:item.startDate}});
      for(let i=0;i<array.length;i++){
        //通过属性名找到对应值的所有构件
        let element=Monge.Model.ElementOperator.getElementIdsByAttribute("工序编码",array[i].operationCode)
        for (const key in element) {
          if (Object.hasOwnProperty.call(element, key)) {
            //key 为模型id elementId为构件id组成的数组
            const elementId = element[key];
            for (const item of elementId) {
              Monge.Model.ElementOperator.show(key, item);
              if(array[i].status=="已超期")Monge.Model.ElementOperator.setColor(key, item, "#EB5757")
              else if(array[i].status=="进行中")Monge.Model.ElementOperator.setColor(key, item, "#27AE60")
              else if(array[i].status=="已完成"||array[i].status=="未开始")Monge.Model.ElementOperator.resetColor(key, item)
            }
          }
        }
      }
      /*****已经取出符合条件的任务，接下来就是找对应的构件，并将构件显示与隐藏 */
    },
    to16Color (color) {
      const rgb = color.split(',');
      const r = parseInt(rgb[0].split('(')[1]);
      const g = parseInt(rgb[1]);
      const b = parseInt(rgb[2].split(')')[0]);
      const hex = "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
      return hex;
    },
    getTaskList(data){
      //取出任务列表的所有开始时间
      this.ascend(data);
      this.taskList=data;
    },
    ascend(data){
      const list=data.sort(function(a, b) { return b.startDate > a.startDate ? -1 : 1 })
      this.startDateList=list.map((item)=>{ return item.startDate });
    },
    playVideo(){
      this.isViedo=!this.isViedo
    },
    testHtml(){
      //通过控制index设置开始时间,控制进度条
      this.index++;
      const length=this.startDateList.length
      this.percentage=this.index/length*100
    },
    getLevels(){
      if (!this.mapdata) {
        const levels = Monge.Model.getLevels();
        this.mapoptions = levels;
        this.mapdata = levels[0].elevation;
        this.setLevels();
      } else {
        this.setLevels();
      }
    },
    setLevels(){
      Monge.Model.MiniMap.deactive()
      Monge.Model.MiniMap.active({
        location: 'bottom',
        mapWidth: 400,
        mapHeight: 300,
        tools:{
          zoom:false,
          close:false
        },
        height: this.mapdata + 5,
        deactiveCB:(val,data)=>{
          // this.showminimaplevel = false
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.main{
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  background: #fff;
  position: relative;
  .name{
    position: absolute;
    width: 285px;
    height: 40px;
    top: 0px;
    left: 56px;
    border-bottom-right-radius: 10px;
    background: rgba(255, 255, 255, 0.5);
    z-index: 2;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0 10px;
    img{
      width: 25px;
      height: 25px;
      object-fit: contain;
    }
    span{
      width: calc(100% - 25px);
      color: #fff;
      line-height: 40px;
      font-size: 14px;
      font-weight: 400;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      user-select: none;
      text-indent: 3px;
      
    }
  }
}
.minimaplevel {
  width: 150px;
  position: absolute;
  left: 250px;
  bottom: 302px;
  z-index: 11;
  /deep/.el-select{
    background-color: rgba(0, 0, 0, 0.3) !important;
  }
}
.bottom{
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 40%;
  background: rgba(255, 255, 255, 0.9);
}
.title{
  padding: 10px 148px;
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px Solid #D4D8E0;
  span{
    font-size: 15px;
    color: #2E384D;
    line-height: 20px;
  }
  .viedo{
    width: 80%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .progress{
    width: 85%;
    /deep/.el-progress-bar__inner{
      background-color: #3793FF;
    }
  }
  .el-icon-video-play ,.el-icon-video-pause{
    font-size: 20px;
    margin-right: 10px;
    color: #4E5862;
    cursor: pointer;
  }
}
.taskList{
  width: 100% !important;
  height: calc(100% - 50px) !important;
}
</style>
